import { gql } from "@apollo/client";

const CONTACT_FIELDS = `
  contactId
  contactKey
  label
  phone
  priority
  isActive
  daysOfWeek
  startMinute
  endMinute
  isAvailable
  hoursLabel
  updatedBy
  updatedAt
`;

export const GET_SUPPORT_CONTACTS = gql`
  query SupportContacts($contactKey: String) {
    supportContacts(contactKey: $contactKey) {
      ${CONTACT_FIELDS}
    }
  }
`;

export const CREATE_SUPPORT_CONTACT = gql`
  mutation CreateSupportContact($input: SupportContactInput!) {
    createSupportContact(input: $input) {
      success
      message
      contact { ${CONTACT_FIELDS} }
    }
  }
`;

export const UPDATE_SUPPORT_CONTACT = gql`
  mutation UpdateSupportContact($contactId: String!, $input: SupportContactInput!) {
    updateSupportContact(contactId: $contactId, input: $input) {
      success
      message
      contact { ${CONTACT_FIELDS} }
    }
  }
`;

export const DELETE_SUPPORT_CONTACT = gql`
  mutation DeleteSupportContact($contactId: String!) {
    deleteSupportContact(contactId: $contactId) {
      success
      message
    }
  }
`;
